import { CREATOR_ACCOMMODATION_STEPS, STEPS } from 'routes/steps'
import { useApp } from 'store/steps'
import DesktopNavigation from './DesktopNavigation'

const CreatorDesktopNavigation = () => {
    const { stepId, isCreatorAccommodation } = useApp()

    return (
        <DesktopNavigation
            steps={isCreatorAccommodation ? CREATOR_ACCOMMODATION_STEPS : STEPS}
            stepId={stepId}
        />
    )
}

export default CreatorDesktopNavigation
